import React, { useEffect } from "react";
import { combineClassNames, reactParserCommonOptions } from "app/functions";
import closeIconPath from "assets/icons/login-x-icon.svg";
import "./index.scss";
import BenefitsSlider from "../../../shared/benefits-slider/benefits-slider";
import ReactHtmlParser from "react-html-parser";
import { createAnalyticsItemsList } from "app/functions";
import AnalyticsManager from "app/analytics";
import HtmlContent from 'components/html/HtmlContent';

const SubsidyPopup = ({
  header,
  content,
  benefits,
  handleClose,
  backdropClick,
  status,
  footerText,
}) => {
  const closePopup = () => {
    handleClose();
  };

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      backdropClick();
    }
  };

  useEffect(() => {
    const element = document.querySelector(".popup-content");
    if (element) {
      element.style.overflowX = "unset";
    }
  }, []);

  const onBenefitClick = (benefit, status) => {
    if (status) {
      AnalyticsManager.logUpsalePopupProductClick(status);
      let items = createAnalyticsItemsList([benefit], {
        item_list_name: "upsale_popup",
      });
      AnalyticsManager.logSelectItem(items);
    }
    handleClose();
  };

  const benefitsCount = Array.isArray(benefits)
    ? benefits.length
    : benefits
      ? Object.keys(benefits).length
      : 0;

  return (
    <div
      className={combineClassNames("backdrop", "active")}
      onClick={handleBackdropClick}
    >
      <div className="subsidy-popup" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="popup-close-button"
          onClick={closePopup}
          aria-label="Close Popup"
        >
          <img src={closeIconPath} alt="Close Icon" />
        </button>

        <div className="popup-content">
          <div className="popup-main-content">
            <div className="content">
              {ReactHtmlParser(
                content,
                reactParserCommonOptions({
                  openLinksInNewTab: true,
                })
              )}
            </div>
            {benefitsCount > 0 && (
              <BenefitsSlider
                data={{ benefits }}
                itemPerRow={benefitsCount}
                shouldAddActionButton={true}
                hideFavourites={true}
                onBenefitClick={(benefit) =>
                  benefit ? onBenefitClick(benefit, status) : null
                }
                status={status}
              />
            )}
            {footerText && (
              <div style={{marginTop: '20px', textAlign: 'center'}}>
                <HtmlContent content={footerText} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubsidyPopup;
